import styled from "styled-components";
import { ArrowRight, BarChart, Icon1Circle, Icon2Circle, Keyboard, ShieldX, UpcScan } from "react-bootstrap-icons";
import { Mode } from "../types/Mode";
import { useMode } from "../context/ModeContext";
import { useCookies } from "react-cookie";
import { useState } from "react";

const Navigation = styled.div`
  background: rgb(21, 23, 26);
  // background: #1a1c1e;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  flex-direction: column;
  max-width: 450px;
  margin: auto;
  margin-top: 20px;

  &:first-child {
    margin-top: 0;
  }
`;

const Link = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #202527;
  }

  .left {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  .icon {
    width: 26px;
    height: 26px;
    color: #ffffff;
  }

  & > .icon {
    color: #808080;
  }
`;

const Author = styled.div`
  margin: 15px;
  font-size: 13px;
  text-align: center;
  color: #ffffff;
`;

const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #333;
    transition: 0.4s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #ffcc00;
  }

  input:checked + .slider:before {
    transform: translateX(24px);
  }
`;

export const NavigationPage = () => {
  const { changeMode } = useMode();
  const [, , removeCookie] = useCookies(["access_key"]);

  const [manualInput, setManualInput] = useState(() => {
    return localStorage.getItem("manual_input") === "true";
  });

  const toggleInputMode = () => {
    const newVal = !manualInput;
    setManualInput(newVal);
    localStorage.setItem("manual_input", String(newVal));
  };

  const [singleManageMode, setSingleManageMode] = useState(() => {
    return localStorage.getItem("single_manage_mode") === "true";
  });

  const toggleSingleManageMode = () => {
    const newVal = !singleManageMode;
    setSingleManageMode(newVal);
    localStorage.setItem("single_manage_mode", String(newVal));
  };

  return (
    <>
      <Navigation>
        <Link onClick={() => changeMode(Mode.STATS)}>
          <div className="left">
            <BarChart className="icon" />
            Zapełnienie magazynu
          </div>
          <ArrowRight className="icon" />
        </Link>
      </Navigation>
      <Navigation>
        <SectionTitle>Ustawienia</SectionTitle>
        <Link>
          <div className="left">
            {manualInput ? <Keyboard className="icon" /> : <UpcScan className="icon" />}
            <div>
              <div style={{ fontSize: "16px" }}>Tryb wprowadzania</div>
              <div style={{ fontSize: "12px", color: "#808080" }}>
                {manualInput ? "Klawiatura ekranowa" : "Skaner sprzętowy"}
              </div>
            </div>
          </div>
          <Switch>
            <input type="checkbox" checked={manualInput} onChange={toggleInputMode} />
            <span className="slider"></span>
          </Switch>
        </Link>
        <Link>
          <div className="left">
            {singleManageMode ? <Icon1Circle className="icon" /> : <Icon2Circle className="icon" />}
            <div>
              <div style={{ fontSize: "16px" }}>Tryb zarządzania</div>
              <div style={{ fontSize: "12px", color: "#808080" }}>{singleManageMode ? "Pojedyńczy" : "Podwójny"}</div>
            </div>
          </div>
          <Switch>
            <input type="checkbox" checked={singleManageMode} onChange={toggleSingleManageMode} />
            <span className="slider"></span>
          </Switch>
        </Link>
        <Link onClick={() => removeCookie("access_key")}>
          <div className="left">
            <ShieldX className="icon" />
            Usuń klucz dostępu
          </div>
        </Link>
      </Navigation>
      {/* <Navigation>
                <div>DEV - testy, nie używać!</div>
                <Link onClick={() => changeMode(Mode.CREATE)}><div className="left"><ArrowUpSquare className="icon" />Schowaj palete</div><ArrowRight className="icon" /></Link>
                <Link onClick={() => changeMode(Mode.DELETE)}><div className="left"><ArrowDownSquare className="icon" />Zdejmij palete</div><ArrowRight className="icon" /></Link>
                <Link onClick={() => changeMode(Mode.CHECK)}><div className="left"><Pass className="icon" />Sprawdż paletę</div><ArrowRight className="icon" /></Link>
            </Navigation> */}
      <Author>Concept, design & implementation by Jarosław Krupicki</Author>
    </>
  );
};
